import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import * as FileSaver from 'file-saver/FileSaver';
import { Store } from '@ngrx/store';

import * as SustainabilityActions from '@core/actions/sustainability.action';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class SustainabilityService {

  constructor(
    private http: HttpClient,
    private store: Store<any>
  ) { }
  
  getFollowParentsIds(){
    return this.http.get<any>(`${API}sustainability/followParents`);
  }

  getProvidersByParentId(parentId){
    return this.http.get<any>(`${API}sustainability/providers?parentId=${parentId}`);
  }

  getLink(file, parentId){
    const mimeType = file.type;
    const name = file.name;
    const FileableType = 'SustainabilityGroup';

    return this.http.post<string>(`${API}sustainability/link`, {
      mimeType: mimeType,
      name: name,
      FileableType: FileableType,
      parentId: parentId
    })
  }

  uploadGroup(link, file){
    return this.http.put<any>(`${link}`, file);
  }

  processUploadGroup(fileId, parentId){
    return this.http.post<any>(`${API}sustainability/uploadGorup`, {
      fileId: fileId,
      parentId: parentId
    });
  }

  exportConsolidate(parentId){
    return this.http
      .get(`${API}sustainability/exportConsolidate?parentId=${parentId}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, `Sostenibilidad.xlsx`);
          this.store.dispatch(new SustainabilityActions.ExportByProviderIdSuccess());
        },
        err => {
          this.store.dispatch(new SustainabilityActions.ExportByProviderIdFail(err));
        }
    );
  }

  exportProviders(parentId, providerId?, providerName?){
    if(providerId){
      return this.http
      .get(`${API}sustainability/export?parentId=${parentId}&providerId=${providerId}`, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          const name = providerName ? `Sostenibilidad - ${providerName}` : 'Sostenibilidad'
          FileSaver.saveAs(blob, `${name}.xlsx`);
          this.store.dispatch(new SustainabilityActions.ExportByProviderIdSuccess());
        },
        err => {
          this.store.dispatch(new SustainabilityActions.ExportByProviderIdFail(err));
        }
      );
    }else{
      const data = {
        parentId: parentId
      }
      return this.http.post(`${API}sustainability/export`, data).subscribe(
        response => {
          this.store.dispatch(
            new SustainabilityActions.ExportGroupPending({
              status: 'pending',
              message: 'Generando sostenibilidad...'
            })
          );
        },
        err => {
          this.store.dispatch(new SustainabilityActions.ExportGroupFail(err));
        });
    }
  }

  downloadGroup(downloadUrl, name) {
    return this.http
      .get(downloadUrl, {
        responseType: 'blob',
        observe: 'response'
      })
      .subscribe(
        response => {
          const blob = response.body;
          FileSaver.saveAs(blob, name);
          this.store.dispatch(
            new SustainabilityActions.ExportGroupDownloadSuccess()
          );
        },
        err => {
          this.store.dispatch(
            new SustainabilityActions.ExportGroupDownloadFail(err)
          );
        }
      );
  }

  acceptedChanges(data){
    return this.http.post<any>(`${API}sustainability/acceptedChanges`,data);
  }

}
